/**
 * Finding athletes on the event map by bib or name (docs/features/athletes-and-trackers.md, Map): in the browser, over
 * the roster the map already holds, so typing costs no request.
 */

/** Lower case without accents, so "zoe" finds "Zoë". */
function fold(text: string): string {
  return text.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase().trim()
}

/** Whether `athlete` answers `query`: a bib that starts with it, or a name holding each of its words. */
export function matchesAthlete(athlete: { name: string; bib: string | null }, query: string): boolean {
  const wanted = fold(query)
  if (!wanted) return false
  if (athlete.bib && fold(athlete.bib).startsWith(wanted)) return true
  const name = fold(athlete.name)
  return wanted.split(/\s+/).every((word) => name.includes(word))
}

/**
 * The athletes a search can find on a map that draws only an area (the play world's, inclusive of its edges); with
 * none, every athlete with a position.
 */
export function withinArea<T extends { latitude: number; longitude: number }>(
  athletes: readonly T[],
  area: { north: number; south: number; east: number; west: number } | null,
): readonly T[] {
  if (!area) return athletes
  return athletes.filter(
    (athlete) => athlete.latitude >= area.south && athlete.latitude <= area.north && athlete.longitude >= area.west && athlete.longitude <= area.east,
  )
}
